import { render, staticRenderFns } from "./FoundStartupsModal.vue?vue&type=template&id=283312e4&scoped=true"
import script from "./FoundStartupsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FoundStartupsModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283312e4",
  null
  
)

export default component.exports